import { finalize } from 'rxjs/operators';
import { GaleriaVehiculoService } from './../../../../services/galeria-vehiculo.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Directorios } from './../../../../../../_entities/galeria/Directorios';
import { ListaImagenes } from './../../../../../../_entities/galeria/ListaImagenes';
import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';

@Component({
	selector: 'kt-galeria-vehiculo',
	templateUrl: './galeria-vehiculo.component.html',
	styleUrls: ['./galeria-vehiculo.component.scss']
})
export class GaleriaVehiculoComponent implements OnInit {
	@ViewChild('myImage', { static: true }) image: ElementRef

	public fechaImagen;
	public lista: ListaImagenes[];
	public directorios: Directorios[];
	public fotosCarpeta: ListaImagenes[];

	public imagen: boolean = false;
	public bloqueo: boolean = false;
	public atras: boolean = false;
	public showDirectorios: boolean = true;
	public loading: boolean = false;
	public showFilterRow: boolean;

	public img: any;

	public listado;
	public fechaInicial;
	public fechaFinal;
	public fechaInicio;
	public idVehiculo;
	public fechaFin;
	public imei;
	public carpeta;
	public galeria;
	public i: number = 0;

	constructor(private toastService: ToastrService,
		private datepipe: DatePipe,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<GaleriaVehiculoComponent>,
		private galeriaVehiculoService: GaleriaVehiculoService) { }

	ngOnInit() {
		this.imei = this.data;
		this.obtenerListaImagenes(this.imei);
		this.obtenerDirectoriosImei(this.imei);
	}

	/**Lista de imagenes */
	obtenerListaImagenes(imei) {
		this.galeriaVehiculoService.obtenerListaImagenes(imei).subscribe(result => {
			this.lista = result;
			this.obtenerImagen(this.lista[0].imei, this.lista[0].foto, this.lista[0].fecha)
		})
	}

		/**Obtener directorios por imei */
		obtenerDirectoriosImei(imei) {
			this.galeriaVehiculoService.obtenerDirectorios(imei).subscribe(result => {
				this.directorios = result;
			})
		}


	/**Obtener imagen especifica */
	obtenerImagen(imei, foto, fecha?) {
		this.loading = true;
		this.galeriaVehiculoService.obtenerImagenEspecifica(imei, foto).pipe((finalize(() => this.loading = false))).subscribe(result => {
			this.image.nativeElement.src = window.URL.createObjectURL(result)
			this.fechaImagen = this.datepipe.transform(fecha, "yyyy-MM-dd H:mm a");

		})
	}

	/**Obtener Reporte Velocidad */
	reporteFotos(fechaInicio: Date, fechaFin: Date) {
		this.loading = true;
		this.fechaInicial = this.datepipe.transform(fechaInicio, "yyyy-MM-dd HH:mm:ss");
		this.fechaFinal = this.datepipe.transform(fechaFin, "yyyy-MM-dd HH:mm:ss");
		this.galeriaVehiculoService.obtenerGaleria(this.data, this.fechaInicial, this.fechaFinal).pipe(
			finalize(
				() => { this.loading = false}
			)
		).subscribe(res => {
			this.galeria = res;
			this.obtenerImagen(this.galeria[0].imei, this.galeria[0].foto, this.galeria[0].fecha)
		})
	}

	/**Obtener Archivos de la carpeta */
	obtenerArchivos(nombre) {
		this.carpeta = nombre;
		this.galeriaVehiculoService.obtenerArchivosDirectorio(this.imei, nombre).subscribe(result => {
			this.showDirectorios = false;
			this.fotosCarpeta = result
		})
	}


	/**Obtener Foto de una carpeta seleccionada */
	obtenerFotoCarpeta(nombre) {
		this.loading = true;
		this.galeriaVehiculoService.obtenerFotoCarpeta(this.imei, this.carpeta, nombre).pipe((finalize(() => this.loading = false))).subscribe(result => {
			this.image.nativeElement.src = window.URL.createObjectURL(result)
		}, err => {
			//this.toastService.error("No se encontro la foto seleccionada")
		})
	}
	regresarCarpetas() {
		this.showDirectorios = true;
	}

	prev() {
		if (this.i <= 0)
			this.i = this.galeria.length;
		this.i--;
		return this.obtenerImagen(this.galeria[this.i].imei, this.galeria[this.i].foto, this.galeria[this.i].fecha);
	}

	next() {
		if (this.i >= this.galeria.length - 1)
			this.i = -1;
		this.i++;
		return this.obtenerImagen(this.galeria[this.i].imei, this.galeria[this.i].foto,  this.galeria[this.i].fecha);
	}


	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}


}
